import axios from '@/libs/api.request'

/**
 * 获取公告列表
 * @param {Number} page 页码，默认1
 * @param {Number} limit 每页数量，默认30
 * @param {String} key 搜索关键字（模糊搜索标题）
 * @param {Object} params 其他参数（status, category_id）
 */
export const getAnnouncementList = (page = 1, limit = 30, key = '', params = {}) => {
  return axios.request({
    url: '/v2/announcement/list',
    method: 'get',
    params: {
      page,
      limit,
      key,
      status: params.status,
      category_id: params.category_id
    }
  })
}

/**
 * 获取公告详情
 * @param {Number} id 公告ID
 */
export const getAnnouncementDetail = (id) => {
  return axios.request({
    url: `/v2/announcement/detail/${id}`,
    method: 'get'
  })
}

/**
 * 添加公告
 * @param {Object} data 公告数据
 */
export const addAnnouncement = (data) => {
  return axios.request({
    url: '/v2/announcement/add',
    method: 'post',
    data
  })
}

/**
 * 更新公告
 * @param {Object} data 公告数据
 */
export const updateAnnouncement = (data) => {
  return axios.request({
    url: '/v2/announcement/update',
    method: 'put',
    data
  })
}

/**
 * 删除公告
 * @param {Number} id 公告ID
 */
export const deleteAnnouncement = (id) => {
  return axios.request({
    url: '/v2/announcement/delete',
    method: 'delete',
    data: { id }
  })
}

/**
 * 获取公告分类列表
 */
export const getAnnouncementCategories = () => {
  return axios.request({
    url: '/v2/announcement/category/list',
    method: 'get'
  })
}

/**
 * 添加公告分类
 * @param {Object} data 分类数据
 */
export const addAnnouncementCategory = (data) => {
  return axios.request({
    url: '/v2/announcement/category/add',
    method: 'post',
    data
  })
}

/**
 * 更新公告分类
 * @param {Object} data 分类数据
 */
export const updateAnnouncementCategory = (data) => {
  return axios.request({
    url: '/v2/announcement/category/update',
    method: 'put',
    data
  })
}

/**
 * 删除公告分类
 * @param {Number} id 分类ID
 */
export const deleteAnnouncementCategory = (id) => {
  return axios.request({
    url: '/v2/announcement/category/delete',
    method: 'delete',
    data: { id }
  })
}
